import Axios from "lib/axiosInterceptor";

const currentUrl = window.location.href;

export const _setThumbnail = (data) => {
  return Axios.post("/Presentation/SetThumbnail", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const _uploadPPT = (data, config) => {
  return Axios.post("/document/upload", data, {
    ...config,
    headers: {
      "Content-Type": "multipart/form-data",
      ...(config.headers || {}),
    },
  });
};

export const _getSlideStream = (id, publicationId, eventId) => {
  return Axios({
    url: `/Document/stream/public/${id}?presentationId=${
      publicationId ? publicationId : ""
    }&eventId=${eventId ?? ""}`,
    method: "GET",
    responseType: "blob", // Get the response as a blob
    headers: {
      // Accept: "audio/*",
      Accept: "octet/stream",
      //  "image/jpeg",
    },
  }).catch((err) => {

    if (
      currentUrl?.includes("viewer-mode/") ||
      currentUrl.includes("/active-presentation")
    ) {
      throw err;
    }
  });
};
export const _getSlideStreamPublic = (id, publicationId, eventId) => {
  return Axios({
    url: `/Document/stream/public/${id}`,
    method: "GET",
    responseType: "blob", // Get the response as a blob
    headers: {
      Accept: "octet/stream",
    },
  }).catch((err) => {});
};

export const _getSlideStreamThumbNail = (
  id,
  width,
  height,
  publicationId,
  eventId
) => {
  return Axios({
    url: `/Document/stream/public/${id}?thumbnail=${true}&width=${width}&height=${height}${
      publicationId ? `&presentationId=${publicationId}` : ""
    }${eventId ? `&eventId=${eventId}` : ""}`,
    method: "GET",
    responseType: "blob", // Get the response as a blob
    headers: {
      // Accept: "audio/*",
      Accept: "octet/stream",
      //  "image/jpeg",
    },
  }).catch((err) => {

  });
};

export const _translateQuestion = (audio, data) => {
  const { presentationId, presentaConnectionId, eventId } = data ?? {};
  return Axios.post(
    `/Document/QuestionByAudio?presentationId=${presentationId}&presentaConnectionId=${presentaConnectionId}&eventId=${eventId}`,
    audio,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

export const _downloadSlide = (
  slideId,
  presentationId,
  presentaConnectionId
) => {
  return Axios({
    url: `/Document/download/${slideId}?presentationId=${presentationId}&presentaConnectionId=${presentaConnectionId}`,
    method: "GET",
    responseType: "blob",
    headers: {
      Accept: "application/octet-stream",
    },
  });
};
